import api from "./api";

export const createReview = (eventId, payload) =>
  api.post(`/events/${eventId}/reviews`, payload).then((res) => res.data);

export const deleteReview = (reviewId) =>
  api.delete(`/reviews/${reviewId}`).then((res) => res.data);
